import { render, staticRenderFns } from "./equipment1.vue?vue&type=template&id=24d4495b&scoped=true"
import script from "./equipment1.vue?vue&type=script&lang=js"
export * from "./equipment1.vue?vue&type=script&lang=js"
import style0 from "./equipment1.vue?vue&type=style&index=0&id=24d4495b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d4495b",
  null
  
)

export default component.exports